module.exports = __webpack_public_path__ + "components/flag/static/square/cw-72ada04083afd95c1d60bba5f6e89afd.svg";